/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";

const DividerComponentDisplay = () => {
    return (
        <div className='simplicity-divider'>
            <hr />
        </div>
    );
};

DividerComponentDisplay.displayName = "DividerComponentDisplay";
export { DividerComponentDisplay };
